<template>
  <body class="login">
    <TopBar />
    <div class="login__background login__background--invitation">
      <aside>
        <div id="invitation-background">
          <div class="grid grid--center">
            <div
              class="grid__cell col10-of-12"
              style="max-width: 480px; padding: 0;"
            >
              <div class="flex-column">
                <div style="width: 100%; margin-bottom: 1rem;">
                  <svg
                    width="32"
                    height="28"
                    viewBox="0 0 32 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M29 14C29.8125 14 30.5 14.3125 31.125 14.875C31.6875 15.5 32 16.1875 32 17V25C32 25.875 31.6875 26.5625 31.125 27.125C30.5 27.75 29.8125 28 29 28H21C20.125 28 19.4375 27.75 18.875 27.125C18.25 26.5625 18 25.875 18 25V10C18 8.25 18.4375 6.5625 19.3125 5C20.1875 3.5 21.4375 2.25 23 1.375C24.5 0.5 26.1875 0 28 0H28.5C28.875 0 29.25 0.1875 29.5625 0.4375C29.8125 0.75 30 1.125 30 1.5V4.5C30 4.9375 29.8125 5.3125 29.5625 5.5625C29.25 5.875 28.875 6 28.5 6H28C26.875 6 25.9375 6.4375 25.1875 7.1875C24.375 8 24 8.9375 24 10V14H29ZM11 14C11.8125 14 12.5 14.3125 13.125 14.875C13.6875 15.5 14 16.1875 14 17V25C14 25.875 13.6875 26.5625 13.125 27.125C12.5 27.75 11.8125 28 11 28H3C2.125 28 1.4375 27.75 0.875 27.125C0.25 26.5625 0 25.875 0 25V10C0 8.25 0.4375 6.5625 1.3125 5C2.1875 3.5 3.4375 2.25 5 1.375C6.5 0.5 8.1875 0 10 0H10.5C10.875 0 11.25 0.1875 11.5625 0.4375C11.8125 0.75 12 1.125 12 1.5V4.5C12 4.9375 11.8125 5.3125 11.5625 5.5625C11.25 5.875 10.875 6 10.5 6H10C8.875 6 7.9375 6.4375 7.1875 7.1875C6.375 8 6 8.9375 6 10V14H11Z"
                      fill="#A26CBA"
                    />
                  </svg>
                </div>
                <p class="fs-md quote">
                  PartnerPage is dead simple to set up, looks polished and
                  enterprise, and the team are an absolute pleasure to work
                  with.
                </p>

                <div
                  style="display: flex; align-items: center; justify-content: left; max-width: 480px;"
                >
                  <img
                    class="headshot"
                    src="../../assets/hawke-riya.png"
                    alt="Riya Jindal, Partnerships Manager"
                  />
                  <p class="name">
                    Riya Jindal, Partnerships Manager
                  </p>
                  <img
                    class="logo"
                    src="../../assets/hawke-logo.png"
                    alt="Hawke Media Logo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
      <div
        class="login_form_invitation"
        style="background-color: #f7f7f7; display: flex; padding: 0 6%; align-items: center;"
      >
        <div id="invitation-form" style="width: 100%; max-width: 480px;">
          <h1
            class="fw-bold pb-xs"
            style="color: #363d4d; font-size: 1.5rem; padding-bottom: 1rem;"
          >
            Join {{ companyName }} on PartnerPage
          </h1>
          <p
            class="fc-darker fs-xs pb-md"
            style=" font-size: 14px; padding-bottom: 2rem; color: #363d4d"
          >
            Already have a PartnerPage account?
            <a href="https://directory.partnerpage.io" class="fc-purple">
              Sign in here
            </a>
          </p>
          <form @submit.prevent="submitForm">
            <label class="is-required">
              First Name
              <input
                data-hj-allow
                type="text"
                name="first_name"
                required
                placeholder="Bob"
                id="id_first_name"
                maxlength="50"
                v-model="firstName"
              />
            </label>
            <label class="is-required">
              Last Name
              <input
                data-hj-allow
                type="text"
                name="last_name"
                required
                placeholder="Doe"
                id="id_last_name"
                maxlength="50"
                v-model="lastName"
              />
            </label>
            <label class="is-required is-disabled">
              Company Name
              <input
                disabled="true"
                data-hj-allow
                type="text"
                required
                placeholder="Acme, Inc."
                id="companyName"
                maxlength="255"
                v-model="companyName"
              />
            </label>
            <label class="is-required">
              Email Address
              <input
                type="email"
                name="email"
                required
                placeholder="example@email.com"
                id="id_email"
                v-model="email"
              />
            </label>
            <label class="is-required" style="margin-bottom: 2rem;">
              Password
              <input
                type="password"
                name="password"
                required
                id="id_password"
                v-model="password"
              />
            </label>
            <Button
              bWidth="expanded"
              type="submit"
              style="text-transform: none !important"
            >
              Join PartnerPage
            </Button>
          </form>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import TopBar from '@/components/Invitations/TopBar';
import Button from '@/components/DesignSystem/Button';
import { apiService } from '@/utils/api/index';
import { genericError } from '@/utils/alerts.service';

export default {
  components: {
    TopBar,
    Button,
  },
  data() {
    return {
      companyName: '',
      email: '',
      firstName: '',
      lastName: '',
      password: '',
    };
  },
  async created() {
    const data = await apiService.get(
      `/users/invite/activation/${this.$route.params.id}/`
    );
    this.companyName = data.companyName;
    this.email = data.email;
    this.firstName = data.name.split(' ')[0];
    this.lastName = data.name.split(' ')[1];
  },
  methods: {
    async submitForm() {
      const res = await apiService.post(
        `/users/invite/activation/${this.$route.params.id}/`,
        {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password,
        }
      );

      if (res.status < 400) {
        window.location.replace(
          `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/?accessToken=${res.data.auth0Response.accessToken}&idToken=${res.data.auth0Response.idToken}`
        );
      } else {
        this.$store.dispatch('showUserMessage', genericError);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.headshot {
  width: 72px;
  height: 72px;
  margin: 2rem 1rem 2rem 0;
  border-radius: 5px;
}

.quote {
  font-size: 1.25rem;
}

.name {
  font-size: 0.875rem;
  width: 240px;
  line-height: 21px;
  color: #606060;
}

.logo {
  width: 120px;
  margin-left: 2rem;
}

label {
  font-size: 1rem;
  color: #363d4d;
}
label input {
  width: 100%;
  height: 48px;
  border: 1px solid #dadee6;
  padding: 0.75rem 1rem !important;
}

@media screen and (max-width: 737px) {
  .login_form_invitation {
    padding: 120px 16% !important;
  }
}
</style>
